import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Users, Play, CheckCircle } from 'lucide-react';
export function ProcessFlow() {
  const steps = [{
    icon: <FileText className="w-5 h-5" data-id="element-124" />,
    title: 'Submit',
    desc: 'Submit your challenge'
  }, {
    icon: <Users className="w-5 h-5" data-id="element-125" />,
    title: 'Match',
    desc: 'We assemble a tailored MBA team'
  }, {
    icon: <Play className="w-5 h-5" data-id="element-126" />,
    title: 'Execute',
    desc: 'They execute with Critical Future oversight'
  }, {
    icon: <CheckCircle className="w-5 h-5" data-id="element-127" />,
    title: 'Deliver',
    desc: 'You receive board-level outputs'
  }];
  return <section className="py-24 md:py-32 bg-primary relative overflow-hidden" data-id="element-128">
      {/* Background line */}
      <div className="absolute top-1/2 left-0 w-full h-[1px] bg-border hidden md:block" data-id="element-129" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-131">
          <h2 className="text-xs text-accent tracking-[0.2em] uppercase mb-4" data-id="element-132">
            The Model
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-text-light" data-id="element-133">
            How It Works
          </h3>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-6 relative" data-id="element-134">
          {/* Animated connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-[10%] right-[10%] h-[1px] bg-border" data-id="element-135">
            <motion.div className="h-full bg-accent" initial={{
            width: '0%'
          }} whileInView={{
            width: '100%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeInOut',
            delay: 0.2
          }} data-id="element-136" />
          </div>

          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.3
        }} className="flex flex-col items-center text-center relative" data-id="element-137">
              <div className="w-16 h-16 rounded-full bg-secondary border border-border flex items-center justify-center text-accent mb-6 relative z-10 group hover:border-accent transition-colors duration-300" data-id="element-138">
                {step.icon}
                {/* Glow effect */}
                <div className="absolute inset-0 rounded-full bg-accent/20 blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-139" />
              </div>
              <h4 className="text-xl font-serif text-text-light mb-3" data-id="element-140">
                {step.title}
              </h4>
              <p className="text-sm text-text-muted max-w-[200px]" data-id="element-141">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}